const toSafeAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
};

export const getDisplayedProcessingFee = (feeQuote) => {
  // `tax` is a compatibility alias for platformFee, so it must never be added separately.
  const serviceFee = toSafeAmount(feeQuote?.platformFee ?? feeQuote?.tax);
  const paymentProcessingFee = toSafeAmount(feeQuote?.processingFee);

  return serviceFee + paymentProcessingFee;
};
